import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  FaArrowRight, 
  FaStar, 
  FaHeart, 
  FaShoppingBag, 
  FaEye,
  FaUtensils,
  FaFilter,
  FaSearch
} from 'react-icons/fa';

const Dining = () => {
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const products = [
    {
      id: 1,
      name: '6 Seater Dining Set',
      image: 'https://images.unsplash.com/photo-1615066390971-03e4e1c36ddf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      discount: '28% OFF',
      rating: 4.9,
      category: 'dining set',
      description: 'Wooden dining table with 6 chairs'
    },
    {
      id: 2,
      name: '4 Seater Dining Set',
      image: 'https://images.unsplash.com/photo-1617806118233-18e1de247200?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      discount: '27% OFF',
      rating: 4.8,
      category: 'dining set',
      description: 'Compact dining set for small families'
    },
    {
      id: 3,
      name: 'Dining Table Only',
      image: 'https://images.unsplash.com/photo-1577140917170-285929fb55b7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      discount: '32% OFF',
      rating: 4.7,
      category: 'table',
      description: 'Solid wood dining table'
    },
    {
      id: 4,
      name: 'Dining Chair (Set of 2)',
      image: 'https://images.unsplash.com/photo-1580480055273-228ff5388ef8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      discount: '36% OFF',
      rating: 4.6,
      category: 'chair',
      description: 'Comfortable wooden dining chairs'
    },
    {
      id: 5,
      name: 'Bar Stool (Set of 2)',
      image: 'https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      discount: '33% OFF',
      rating: 4.5,
      category: 'stool',
      description: 'Modern bar stools for kitchen counter'
    },
    {
      id: 6,
      name: 'Corner Dining Set',
      image: 'https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      discount: '26% OFF',
      rating: 4.8,
      category: 'dining set',
      description: 'Space-saving corner dining set'
    },
    {
      id: 7,
      name: 'Dining Bench',
      image: 'https://images.unsplash.com/photo-1580480055273-228ff5388ef8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      discount: '37% OFF',
      rating: 4.4,
      category: 'bench',
      description: 'Wooden dining bench'
    },
    {
      id: 8,
      name: 'Sideboard Cabinet',
      image: 'https://themprojects.com/wp-content/uploads/2017/11/sideboards-buffets-walmart-throughout-dark-brown-sideboards.jpeg',
      discount: '32% OFF',
      rating: 4.7,
      category: 'storage',
      description: 'Sideboard for dining room storage'
    }
  ];

  const filters = [
    { id: 'all', name: 'All Products' },
    { id: 'dining set', name: 'Dining Sets' },
    { id: 'table', name: 'Tables' },
    { id: 'chair', name: 'Chairs' },
    { id: 'storage', name: 'Storage' }
  ];

  const filteredProducts = products.filter(product => {
    const matchesFilter = selectedFilter === 'all' || product.category === selectedFilter;
    const matchesSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         product.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative h-64 bg-gradient-to-r from-green-500 to-teal-500 overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="absolute inset-0 flex items-center justify-center text-center">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Dining Collection
            </h1>
            <p className="text-lg text-white/90 max-w-2xl mx-auto px-4">
              Beautiful dining sets for memorable meals with family
            </p>
          </div>
        </div>
      </div>

      {/* Filters Section */}
      <div className="container mx-auto px-4 py-8">
        {/* Search Bar */}
        <div className="max-w-md mx-auto mb-8">
          <div className="relative">
            <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search products..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-12 pr-4 py-3 rounded-full border border-gray-300 focus:outline-none focus:border-pink-500 focus:ring-2 focus:ring-pink-200 transition-all duration-300"
            />
          </div>
        </div>

        {/* Filter Buttons */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {filters.map((filter) => (
            <button
              key={filter.id}
              onClick={() => setSelectedFilter(filter.id)}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                selectedFilter === filter.id
                  ? 'bg-gradient-to-r from-pink-500 to-blue-500 text-white shadow-lg scale-105'
                  : 'bg-white text-gray-600 hover:text-pink-500 shadow hover:shadow-md'
              }`}
            >
              {filter.name}
            </button>
          ))}
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {filteredProducts.map((product) => (
            <div key={product.id} className="group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden">
              {/* Discount Badge */}
              <div className="absolute top-4 left-4 z-10 bg-gradient-to-r from-pink-500 to-blue-500 text-white px-3 py-1 rounded-full text-xs font-semibold">
                {product.discount}
              </div>

              {/* Image Container */}
              <div className="relative h-56 overflow-hidden">
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center gap-3">
                  <button className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-pink-500 hover:bg-pink-500 hover:text-white transition-all duration-300">
                    <FaShoppingBag size={16} />
                  </button>
                  <button className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-blue-500 hover:bg-blue-500 hover:text-white transition-all duration-300">
                    <FaHeart size={16} />
                  </button>
                  <button className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-purple-500 hover:bg-purple-500 hover:text-white transition-all duration-300">
                    <FaEye size={16} />
                  </button>
                </div>
              </div>

              {/* Product Info */}
              <div className="p-5">
                <h3 className="text-base font-semibold text-gray-800 mb-1 group-hover:text-pink-500 transition-colors duration-300">
                  {product.name}
                </h3>
                <p className="text-xs text-gray-500 mb-2 line-clamp-1">{product.description}</p>
                
                {/* Rating */}
                <div className="flex items-center gap-1 mb-3">
                  <div className="flex">
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} className={`text-xs ${i < Math.floor(product.rating) ? 'text-yellow-400' : 'text-gray-300'}`} />
                    ))}
                  </div>
                  <span className="text-xs text-gray-500">({product.rating})</span>
                </div>

                {/* Price */}
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-2">
                    <span className="text-lg font-bold text-gray-800">{product.price}</span>
                    <span className="text-xs text-gray-400 line-through">{product.oldPrice}</span>
                  </div>
                </div>

                {/* Add to Cart Button */}
                <button className="w-full py-2.5 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-lg text-sm font-semibold hover:shadow-lg transform hover:scale-105 transition-all duration-300">
                  Add to Cart
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* No Results Message */}
        {filteredProducts.length === 0 && (
          <div className="text-center py-16">
            <p className="text-xl text-gray-500">No products found matching your criteria.</p>
          </div>
        )}

        {/* Load More Button */}
        {filteredProducts.length > 0 && (
          <div className="text-center mt-12">
            <button className="px-8 py-3 bg-white text-pink-500 rounded-full font-semibold shadow-md hover:shadow-xl transition-all duration-300 transform hover:scale-105 border-2 border-pink-500 hover:bg-pink-500 hover:text-white">
              Load More Products
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dining;